var React = require('react');

function S17 (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"id":"Rectangle_48492","data-name":"Rectangle 48492","width":"28","height":"28","fill":"none","key":0}),React.createElement("path",{"id":"Path_106563","data-name":"Path 106563","d":"M26.893,12.064C26,10.905,21.37,5.42,17.144,5.42a4.259,4.259,0,0,0-3.309,1.235A4.239,4.239,0,0,0,10.526,5.42c-4.009,0-8.158,4.556-9.749,6.644a.821.821,0,0,0,0,1.005,17.249,17.249,0,0,0,13.058,6.555A17.158,17.158,0,0,0,26.88,13.069a.822.822,0,0,0,0-1.018ZM13.835,17.982A15.14,15.14,0,0,1,3.271,13.4H24.386a15,15,0,0,1-10.551,4.582ZM3.182,11.733C5.41,9.149,8.248,7.062,10.526,7.062S13,8.436,13.008,8.729a.827.827,0,0,0,1.655-.013c0-.064.025-1.655,2.482-1.655,2.138,0,5.04,2.024,7.344,4.671Z","transform":"translate(0.165 1.478)","key":1})]);
}

S17.defaultProps = {"id":"s-04","width":"28","height":"28","viewBox":"0 0 28 28"};

module.exports = S17;

S17.default = S17;
